exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2tUt-{color:#fff;text-decoration:none;transition:color .3s ease}._2tUt-:hover{color:#bababa}._18u_o{margin-bottom:14px;text-align:center;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;width:100%}.kIt-U{-ms-flex:1;flex:1;-ms-flex-item-align:start;align-self:flex-start;font-size:20px;text-align:center}@media (max-width:449px){.kIt-U{font-size:16px}}", ""]);

// exports
exports.locals = {
	"back-button": "_2tUt-",
	"backButton": "_2tUt-",
	"title": "_18u_o",
	"title-text": "kIt-U",
	"titleText": "kIt-U"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/containers/share-overlay/embed-form/header/styles.styl
// module id = 1440
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact